// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';
import ModalController from './modal_controller';
import CheckboxController from './checkbox_controller';
import InputIllustrationController from './form/input_illustration_controller';
import CustomSelectController from './custom_select_controller';
import SelectIconController from './select_icon_controller';
import FormToggleController from './form/toggle_controller';
import ManagementPayslipTimeCounterWarningController from './management/payslip/time_counter_warning_controller';
import MarketplaceCategorySearchController from './marketplace/category_search_controller';
import MarketplaceCategoryController from './marketplace/category_controller';
import MarketplaceSearchAnimationController from './marketplace/search_animation_controller';
import PreventOfferPopoverController from './prevent_offer_popover_controller';
import MarketplaceSearchCategoryController from './marketplace/search_category_controller';
import MarketplaceSearchController from './marketplace/search_controller';
import MarketplaceSearchMapController from './marketplace/search_map_controller';
import MarketplaceConsultationController from './marketplace/consultation_controller';
import MarketplaceProfileController from './marketplace/profile_controller';
import FormProfileController from './form/profile_controller';
import SimulatorHourAlertController from './tool/simulator_hour_alert_controller';
import FormAdReviewController from './form/ad_review_controller';
import ModalOffcanvasController from './modal_offcanvas_controller';
import ClickableController from './clickable_controller';
import AdminCityFormController from './admin/city_form_controller';
import AddressFormController from './form/address_controller';
import DatepickerHelpiconController from './datepicker_helpicon_controller';
import RedirectToController from './redirect_to_controller';
import ManagementPayslipSimulationController from './management/payslip/simulation_controller';

application.register('modal', ModalController);
application.register('form--toggle', FormToggleController);
application.register('form--input-illustration', InputIllustrationController);
application.register('checkbox', CheckboxController);
application.register('custom-select', CustomSelectController);
application.register('select-icon', SelectIconController);
application.register('management--payslip--time-counter-warning', ManagementPayslipTimeCounterWarningController);
application.register('marketplace--search', MarketplaceSearchController);
application.register('marketplace--category', MarketplaceCategoryController);
application.register('marketplace--profile', MarketplaceProfileController);
application.register('marketplace--category-search', MarketplaceCategorySearchController);
application.register('marketplace--search-animation', MarketplaceSearchAnimationController);
application.register('marketplace--search-category', MarketplaceSearchCategoryController);
application.register('marketplace--consultation', MarketplaceConsultationController);
application.register('form--profile', FormProfileController);
application.register('marketplace--search-map', MarketplaceSearchMapController);
application.register('prevent-offer-popover', PreventOfferPopoverController);
application.register('tool--simulator-hour-alert', SimulatorHourAlertController);
application.register('form--ad-review', FormAdReviewController);
application.register('modal-offcanvas', ModalOffcanvasController);
application.register('clickable', ClickableController);
application.register('form--address', AddressFormController);
application.register('management--payslip--simulation', ManagementPayslipSimulationController);

application.register('admin--city-form', AdminCityFormController);
application.register('datepicker-helpicon', DatepickerHelpiconController);
application.register('redirect-to', RedirectToController);
